import {
  Users,
  Database,
  DollarSign,
  CornerDownLeft,
  CornerUpLeft,
  Smartphone,
} from "react-feather";
import {
  GAME_MATCH_VIEW,
  GAME_USER_VIEW,
  SUPPORT_APP_GAME_LIST,
  SUPPORT_APP_USER_LIST,
  GAME_USER_DEPOSIT_VIEW,
  GAME_USER_WITHDRAWAL_VIEW,
  GAME_USER_REFUNDS_VIEW,
} from "../../constants";

const pagesSection = [
  {
    href: "/users",
    icon: Users,
    title: "Users",
    permissions: [GAME_USER_VIEW],
  },
  {
    href: "/matches",
    icon: Database,
    title: "Matches",
    permissions: [GAME_MATCH_VIEW],
  },
  {
    href: "/deposits",
    icon: DollarSign,
    title: "Deposits",
    permissions: [GAME_USER_DEPOSIT_VIEW],
  },
  {
    href: "/withdraws",
    icon: CornerUpLeft,
    title: "Withdraws",
    permissions: [GAME_USER_WITHDRAWAL_VIEW],
  },
  {
    href: "/refunds",
    icon: CornerDownLeft,
    title: "Refunds",
    permissions: [GAME_USER_REFUNDS_VIEW],
  },
  {
    href: "/support-users",
    icon: Users,
    title: "Support Users",
    permissions: [SUPPORT_APP_USER_LIST],
  },
  {
    href: "/games",
    icon: Smartphone,
    title: "Games",
    permissions: [SUPPORT_APP_GAME_LIST],
  },
  // {
  //   href: "/dashboard",
  //   icon: Sliders,
  //   title: "Dashboard",
  //   children: [
  //     {
  //       href: "/dashboard/default",
  //       title: "Default",
  //     },
  //     {
  //       href: "/dashboard/analytics",
  //       title: "Analytics",
  //     },
  //     {
  //       href: "/dashboard/saas",
  //       title: "SaaS",
  //     },
  //   ],
  // },
  // {
  //   href: "/pages",
  //   icon: Layout,
  //   title: "Pages",
  //   children: [
  //     {
  //       href: "/pages/profile",
  //       title: "Profile",
  //     },
  //     {
  //       href: "/pages/settings",
  //       title: "Settings",
  //     },
  //     {
  //       href: "/pages/pricing",
  //       title: "Pricing",
  //     },
  //     {
  //       href: "/pages/chat",
  //       title: "Chat",
  //     },
  //     {
  //       href: "/pages/blank",
  //       title: "Blank Page",
  //     },
  //   ],
  // },
  // {
  //   href: "/projects",
  //   icon: Briefcase,
  //   title: "Projects",
  //   badge: "8",
  // },
  // {
  //   href: "/orders",
  //   icon: ShoppingCart,
  //   title: "Orders",
  // },
  // {
  //   href: "/invoices",
  //   icon: CreditCard,
  //   title: "Invoices",
  //   children: [
  //     {
  //       href: "/invoices",
  //       title: "List",
  //     },
  //     {
  //       href: "/invoices/detail",
  //       title: "Detail",
  //     },
  //   ],
  // },
  // {
  //   href: "/tasks",
  //   icon: CheckSquare,
  //   title: "Tasks",
  //   badge: "17",
  // },
  // {
  //   href: "/calendar",
  //   icon: Calendar,
  //   title: "Calendar",
  // },
  // {
  //   href: "/auth",
  //   icon: Users,
  //   title: "Auth",
  //   children: [
  //     {
  //       href: "/auth/sign-in",
  //       title: "Sign In",
  //     },
  //     {
  //       href: "/auth/sign-up",
  //       title: "Sign Up",
  //     },
  //     {
  //       href: "/auth/reset-password",
  //       title: "Reset Password",
  //     },
  //     {
  //       href: "/auth/404",
  //       title: "404 Page",
  //     },
  //     {
  //       href: "/auth/500",
  //       title: "500 Page",
  //     },
  //   ],
  // },
];

const navItems = [
  {
    title: "",
    pages: pagesSection,
  },
];

export default navItems;
